import SectionProvider from '@builder/sections/SectionProvider'

export const name = 'Blog Categories'
export const group = 'Dynamic Blog Home'
export const beta = false

export const defaultOptions = {
  content: {
    data: {
      type: 'blog-categories-mod',
      categories: []
    }
  }
}

export const icon = ''

export default class ElPostCategories extends SectionProvider {
  constructor (options = {}) {
    super('ElBlogCategories', options)

    this.name = name
    this.group = group
    this.defaultOptions = defaultOptions
  }
}
